import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';

import { useTranslation } from 'react-i18next';

import { PromoFormValues } from 'types/promotion/promotionTypes';
import { FormikProps } from 'formik';
import styles from 'pages/Promotions/styles/promo.module.css';

import { useEffect, useState } from 'react';
import PromoFreeGift from 'pages/Promotions/PromotionManagement/PromoFreeGift';
import PromoReachPurchase from 'pages/Promotions/PromotionManagement/promotionCondition/PromoReachPurchase';

const PromoConditionAndDiscount = ({
  formik,
}: {
  formik: FormikProps<PromoFormValues>;
}) => {
  const { t } = useTranslation();

  // const promotionsState = useSelector((state: RootState) => state.Promotions);

  // const { showAllValidateErrors } = promotionsState;
  const [isGiveaway, setIsGiveaway] = useState('2');
  useEffect(() => {
    const promoT = formik.values.promoType;
    if (promoT === '4' && formik.values.DiscountType !== '3') {
      formik.setFieldValue('DiscountType', '3').then(() => {
        formik.setFieldTouched('DiscountType', true);
      });
    } else if (promoT !== '4' && formik.values.DiscountType === '3') {
      formik.setFieldValue('DiscountType', '1').then(() => {
        formik.setFieldTouched('DiscountType', true);
      });
    } else if (promoT === '3' && formik.values.DiscountType !== '1') {
      formik.setFieldValue('DiscountType', '1').then(() => {
        formik.setFieldTouched('DiscountType', true);
      });
    }
    setIsGiveaway(promoT.toString());
  }, [formik, formik.values.promoType, setIsGiveaway]);

  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">{t('Promo_Condition')}</h5>
      </CardHeader>
      <CardBody className={`${styles['card-body-pd']}`}>
        {isGiveaway === '4' ? (
          <Row data-testid="promo-free-items">
            <Col lg={6}>
              <PromoFreeGift formik={formik} />
            </Col>
            <Col lg={6}></Col>
          </Row>
        ) : (
          <Row data-testid="promo-discount">
            <Col lg={6}>
              <PromoReachPurchase formik={formik} />
            </Col>

            <Col lg={6}></Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};
export default PromoConditionAndDiscount;
